import React from 'react';
import styled from 'styled-components';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import IncompleteList from './IncompleteList';
import { faListCheck } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { COLORS } from 'shared/design-system/settings/variables/Colors';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import { IncompleteSections, ReviewProps } from './utils';

interface ReportIncompleteProps {
  sectionId: 0 | 1 | 2;
  incompleteSections: IncompleteSections[];
  handlePress: ReviewProps['handlePress'];
}

const StyledDiv = styled.div`
  margin-bottom: ${SPACERS.extraLarge};
  .top-section {
    max-width: 700px;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    .icon {
      width: 40px;
      height: 40px;
      margin-bottom: ${SPACERS.small};
      path {
        fill: ${COLORS.ctaPrimary};
      }
    }
    .heading-subheading {
      margin-bottom: ${SPACERS.medium};
    }
  }
`;

const ReportIncomplete: React.FC<ReportIncompleteProps> = ({
  sectionId,
  incompleteSections,
  handlePress,
}) => {
  const handleClick = (item: IncompleteSections) =>
    handlePress(sectionId, item.id - 1);
  return (
    <StyledDiv>
      <div className="top-section">
        <FontAwesomeIcon icon={faListCheck} className="icon" />
        <TrueImpactText className="heading-subheading">
          Just a few final items on your to-do list!
          <br />
          Once you’re done with these, you’ll be able to submit your report.
        </TrueImpactText>
      </div>
      <IncompleteList items={incompleteSections} handleClick={handleClick} />
    </StyledDiv>
  );
};

export default ReportIncomplete;
